import axios from "axios";
import { ModeloItemOrcamento } from "models/modelo_item_orcamento";
import { ModeloItemOrcamentoCategoria } from "models/modelo_item_orcamento_categoria";
import { ModeloItemOrcamentoItens } from "models/modelo_item_orcamento_itens";
import { ModeloItemOrcamentoProduto } from "models/modelo_item_orcamento_produto";
import { UsuarioModel } from "models/user_model";
import { useEffect, useRef, useState } from "react";
import usePaymentForm from "views/admin/finance/paymentForm/hooks/usePaymentForm";
import useMeasureUnit from "../../measureUnit/hooks/useMeasureUnit";
import useProductOrder from "../../product/hooks/useProductOrder";

const useTemplateOrder = () => {
  const [templateList, setList] = useState<ModeloItemOrcamento[]>([]);
  const [itens, setItens] = useState<ModeloItemOrcamentoCategoria[]>([]);
  const [itemList, setItemList] = useState<ModeloItemOrcamentoProduto[]>([]);
  const [usuario, setUsuario] = useState<UsuarioModel>();
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [accountSelected, setAccountSelected] =
    useState<ModeloItemOrcamento>(null);
  const [nome, setNome] = useState("");
  const [errorTitle, setErrorTitle] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const cancelRef = useRef();
  const [showItem, setShowItem] = useState(false);
  const [enableDrag, setEnableDrag] = useState(true);
  const nomeRef = useRef(null);
  const { unidades } = useMeasureUnit();
  const { produtos } = useProductOrder();
  const { condicaoPagamentos } = usePaymentForm();

  const cleanInput = () => {
    setNome("");
    setItens([]);
    setItemList([]);
    setAccountSelected(null);
  };

  const add = () => {
    showModal(true);
  };

  const changeNome = (value: string) => {
    setNome(value);
  };

  const edit = (item: ModeloItemOrcamento) => {
    showModal(true);
    setAccountSelected(item);
    setNome(item.nome);

    const newItens: ModeloItemOrcamentoCategoria[] = [];

    if (item.ModeloOrcamentoItemCategoria.length > 0) {
      item.ModeloOrcamentoItemCategoria.forEach((valor) => {
        const dt: ModeloItemOrcamentoItens[] = [];
        const it : ModeloItemOrcamentoProduto[] = [];
        if (valor?.ModeloOrcamentoItemList?.length > 0) {
          valor.ModeloOrcamentoItemList.forEach((oi) => {
            const itemPrd = produtos.find((prd) => prd.id === oi.produtoId);
            const itemUn = unidades.find((un) => un.id === oi.unidadeMedidaId);
            const add: ModeloItemOrcamentoItens = {
              descricao: oi.descricao,
              id: oi.id,
              produtoId: oi.produtoId,
              modeloOrcamentoItemCategoriaId: oi.modeloOrcamentoItemCategoriaId,
              produtoNome: itemPrd?.nome,
              produtoUnidade: itemPrd?.ProdutoUnidade,
              produtoUnidadeId: oi.produtoUnidadeId,
              quantidade: oi.quantidade,
              unidadeMedidaId: oi.unidadeMedidaId,
              unidadeNome: itemUn?.nome,
              validade: oi.validade,
              valorTotal: oi.valorTotal,
              valorUn: oi.valorUn,
            };
            dt.push(add);
          });
        }
        if(valor?.ModeloOrcamentoItemProdutoList?.length > 0) {
          valor?.ModeloOrcamentoItemProdutoList.forEach((at) => {
            const addItem : ModeloItemOrcamentoProduto ={
              descricao : at.descricao,
              id: at.id,
              modeloOrcamentoItemCategoriaId: at.modeloOrcamentoItemCategoriaId,
              NovoProduto: at.NovoProduto,
              novoProdutoId: at.novoProdutoId,
              quantidade: at.quantidade,
              valorTotal: at.valorTotal,
              valorUn: at.valorUn
            }
            it.push(addItem);
          })
        }
        const cat: ModeloItemOrcamentoCategoria = {
          descricao: valor.descricao,
          modeloOrcamentoItemId: valor.modeloOrcamentoItemId,
          valor: valor.valor,
          id: valor.id,
          ModeloOrcamentoItemList: dt,
          ModeloOrcamentoItemProdutoList: it
        };
        newItens.push(cat);
      });
      setItens(newItens);

    }
  };

  const showModal = (show: boolean) => {
    setShow(show);
    setError(false);
    if (!show) {
      setNome(null);
      setItens([]);
      setAccountSelected(null);
    }
  };

  const showDeleteModal = (item: ModeloItemOrcamento) => {
    setShowDelete(true);
    setAccountSelected(item);
  };

  const closeDelete = () => {
    setShowDelete(false);
  };

  const loadData = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/modelo-itens-orcamento/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));

      setList(response.data);
    }
  };
  const deletar = async () => {
    const response = await axios.delete(
      process.env.REACT_APP_API_URL + "/modelo-itens-orcamento/" + accountSelected?.id
    );
    if (response.data === true) {
      setLoading((prev) => (prev = false));
      showModal(false);
      setNome(null);
      setAccountSelected(null);
      setShowDelete(false);
      await loadData();
    }
  };

  const showItemModal = (show: boolean) => {
    setShowItem(show);
  };

  const closeError = () => {
    setError(false);
  };

  const changeItem = (item: ModeloItemOrcamentoCategoria) => {
    const newItems: ModeloItemOrcamentoCategoria[] = itens.map(
      (existingItem) => {
        if (existingItem.descricao === item.descricao) {
          return item;
        }
        return existingItem;
      }
    );

    newItems.map((value) => {
      let itemTotal = 0;
      if(value?.ModeloOrcamentoItemList?.length > 0){
         itemTotal =  value?.ModeloOrcamentoItemList?.reduce((acc, vl) => acc + Number(vl.valorTotal), 0)
      }
      if(value?.ModeloOrcamentoItemProdutoList?.length > 0) {
        itemTotal += value?.ModeloOrcamentoItemProdutoList?.reduce((acc, vt) => acc + Number(vt.valorTotal), 0)
      }
      value.valor =  itemTotal;
    })

    setItens(newItems);

  };

  const removeItem = (item: ModeloItemOrcamentoCategoria) => {
    let total = 0;
    const list = itens;
    const data = list.filter((data) => data !== item);
    data.forEach((item) => {
      total = total + item.valor;
    });

    setItens(data);
  };

  const saveCategory = () => {
    if (nomeRef.current.value !== null) {
      const categArray = itens;

      const add: ModeloItemOrcamentoCategoria = {
        descricao: nomeRef.current,
        ModeloOrcamentoItemList: [],
        modeloOrcamentoItemId: "",
        valor: 0.0,
        id: "",
        ModeloOrcamentoItemProdutoList: []
      };
      const exists = categArray.find(
        (value) => value.descricao === add.descricao
      );
      if (!exists) {
        categArray.push(add);
        setShowItem(false);
      }
    }
  };

  const isDragable = (drag: boolean) => {
    setEnableDrag(drag);
  };

  const reorder = (
    list: ModeloItemOrcamentoCategoria[],
    startIndex: number,
    endIndex: number
  ) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    setItens(result);
  };

  const showError = (title: string, msg: string) => {
    setError(true);
    setErrorTitle(title);
    setErrorMsg(msg);
  };

  const validate = () => {
    let retorno = true;
    let conta = 0;
    if (nome === null || nome === "") {
      retorno = false;
      showError("Erro!", "Preencha Corretamenete o Descrição do Template");
    }

    if (itens.length === 0) {
      retorno = false;
      showError("Erro!", "Você deve ao menos inserir um grupo");
    }

    if (itens.length > 0) {
      itens.forEach((item) => {
        conta = item.ModeloOrcamentoItemList.length;
        if (conta === 0) {
          retorno = false;
          showError(
            "Erro!",
            "Você deve ao menos inserir ao menos um item no grupo"
          );
          return;
        }
      });
    }

    return retorno;
  };

  const insertRegister = async () => {
    setLoading(true);
    const addOrder = {
      idEmpresa: usuario?.idEmpresa,
      nome: nome,
    };

    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/modelo-itens-orcamento/",
      addOrder
    );
    if (response.data) {
      const id = response.data;
      if (itens?.length > 0) {
        itens.forEach(async (item) => {
          const addCategory = {
            modeloOrcamentoItemId: id,
            descricao: item.descricao,
            valor: item.valor,
          };
          const categ = await axios.post(
            process.env.REACT_APP_API_URL + "/modelo-itens-orcamento/category/",
            addCategory
          );
          if (categ.data) {
            const categId = categ.data;
            if (item.ModeloOrcamentoItemList.length > 0) {
              item.ModeloOrcamentoItemList.forEach(async (val) => {
                const addItem = {
                  modeloOrcamentoItemCategoriaId: categId,
                  produtoId: val.produtoId,
                  descricao: val.produtoNome,
                  unidadeMedidaId: val.unidadeMedidaId,
                  quantidade: val.quantidade,
                  valorUn: val.valorUn,
                  valorTotal: val.valorTotal,
                };
                await axios.post(
                  process.env.REACT_APP_API_URL + "/modelo-itens-orcamento/itens/",
                  addItem
                );
              });
            }
            if (item.ModeloOrcamentoItemProdutoList.length > 0) {
              item.ModeloOrcamentoItemProdutoList.forEach(async (val) => {
                const addProd  = {
                  modeloOrcamentoItemCategoriaId: categId,
                  descricao: val.NovoProduto.nome,
                  novoProdutoId: val.novoProdutoId,
                  quantidade: val.quantidade,
                  valorUn: val.valorUn,
                  valorTotal: val.valorTotal,
                };
                await axios.post(
                  process.env.REACT_APP_API_URL + "/modelo-itens-orcamento/produtos/",
                  addProd
                );
              });
            }
          }
        });
      }

      setLoading(false);
      showModal(false);
      cleanInput();
      setTimeout(async () => {
        await loadData();
      }, 1000);
    }

    setLoading(false);
  };
  const updateRegister = async () => {
    setLoading(true);
    const updateOrder = {
      id: accountSelected.id,
      nome: nome,
    };

    const response = await axios.patch(
      process.env.REACT_APP_API_URL + "/modelo-itens-orcamento/" + accountSelected.id,
      updateOrder
    );
    if (response.data) {
      const id = accountSelected.id;

      if (itens?.length > 0) {
        const removeCateg = await axios.delete(
          process.env.REACT_APP_API_URL + "/modelo-itens-orcamento/category/" + id
        );
        if (removeCateg.data === true) {
          itens?.forEach(async (item) => {
            if (item.id !== "") {
              await axios.delete(
                process.env.REACT_APP_API_URL + "/modelo-itens-orcamento/itens/" + item.id
              );
            }

            const addCategory = {
              modeloOrcamentoItemId: id,
              descricao: item.descricao,
              valor: item.valor,
            };
            const categ = await axios.post(
              process.env.REACT_APP_API_URL + "/modelo-itens-orcamento/category/",
              addCategory
            );
            if (categ.data) {
              const categId = categ.data;
              if (item.ModeloOrcamentoItemList.length > 0) {
                item.ModeloOrcamentoItemList.forEach(async (val) => {
                  const addItem = {
                    modeloOrcamentoItemCategoriaId: categId,
                    produtoId: val.produtoId,
                    descricao: val.produtoNome,
                    unidadeMedidaId: val.unidadeMedidaId,
                    quantidade: val.quantidade,
                    valorUn: val.valorUn,
                    valorTotal: val.valorTotal,
                  };
                  await axios.post(
                    process.env.REACT_APP_API_URL + "/modelo-itens-orcamento/itens/",
                    addItem
                  );
                });
              }
              if (item.ModeloOrcamentoItemProdutoList.length > 0) {
                item.ModeloOrcamentoItemProdutoList.forEach(async (val) => {
                  const addProd  = {
                    modeloOrcamentoItemCategoriaId: categId,
                    descricao: val.NovoProduto.nome,
                    novoProdutoId: val.novoProdutoId,
                    quantidade: val.quantidade,
                    valorUn: val.valorUn,
                    valorTotal: val.valorTotal,
                  };
                  await axios.post(
                    process.env.REACT_APP_API_URL + "/modelo-itens-orcamento/produtos/",
                    addProd
                  );
                });
              }
            }
          });
        }
      }

      setLoading(false);
      showModal(false);
      cleanInput();
      setTimeout(async () => {
        await loadData();
      }, 1000);
    }

    setLoading(false);
  };

  const save = async () => {
    if (validate()) {
      if (accountSelected) {
        await updateRegister();
      } else {
        await insertRegister();
      }
    }
  };

  const addRowItem = (item: ModeloItemOrcamentoProduto, categ: ModeloItemOrcamentoCategoria) => {
    const itens  = [...itemList];
    const existe =  itens.find((a) => a.novoProdutoId === item.novoProdutoId);
    if(existe) {
      showError('Erro!',  'Produto já existe na lista')
    } else {
      itens.push(item);
    }
    setItemList(itens);   

    categ.ModeloOrcamentoItemProdutoList = itens;
    changeItem(categ);

  }

  const deleteRow =(item: ModeloItemOrcamentoProduto, categ: ModeloItemOrcamentoCategoria) => {
    const newList =  itemList.filter((dt) => dt !== item);
    setItemList(newList);
    categ.ModeloOrcamentoItemProdutoList = newList;
    changeItem(categ);

   }

  const editRow = (item: ModeloItemOrcamentoProduto, categ: ModeloItemOrcamentoCategoria) => {
    const newItems: ModeloItemOrcamentoProduto[] = itemList.map((existingItem) => {
      if (existingItem.novoProdutoId === item.novoProdutoId) {
        return item;
      }
      return existingItem;
    });
    setItemList(newItems);
    categ.ModeloOrcamentoItemProdutoList = newItems;
    changeItem(categ);

  }


  useEffect(() => {
    loadData();
  }, []);
  return {
    templateList,
    itens,
    itemList,
    usuario,
    loading,
    show,
    error,
    showDelete,
    accountSelected,
    nome,
    errorTitle,
    errorMsg,
    cancelRef,
    add,
    edit,
    closeDelete,
    deletar,
    showDeleteModal,
    changeNome,
    closeError,
    showModal,
    showItemModal,
    showItem,
    nomeRef,
    changeItem,
    removeItem,
    saveCategory,
    isDragable,
    enableDrag,
    reorder,
    save,
    condicaoPagamentos,
    addRowItem,
    editRow,
    deleteRow,
    
  };
};
export default useTemplateOrder;
